<ng-container *ngIf="subtitleList.length > 0">
  <div class="container">
    <div class="content">
      <span>{{ 'MARRIOTT.SUBTITLE_1' | translate }}</span>
      <img class="subtitle-icon" src="assets/images/icons/subtitles-icon_RC-RUWIDO.png" alt="" />
      <span>{{ 'MARRIOTT.SUBTITLE_2' | translate }}</span>
      <div class="subtitle-list">
        <ng-container *ngFor="let item of subtitleList; index as i; let last = last">
          <span
            class="htv-selectable htv-force-direction"
            [class.selected-subtitle]="isSubtitleEnabled && i === currentIndex"
            (click)="selectTrack(item)"
            [innerText]="item.label"></span>
          <span *ngIf="!last">, </span>
        </ng-container>
      </div>
    </div>
  </div>
</ng-container>
